import { makeStyles } from '@material-ui/core/styles';

export const FooterStyle = makeStyles((theme) => ({
  footer: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
  },

  containerFooter: {
    width: '100% ',
    display: 'flex',
    justifyContent: 'flex-end',
    backgroundColor: 'transparent',
    flexDirection: 'column',
    alignItems: 'center',

    [theme.breakpoints.down('xs')]: {
      fontSize: '10px',
      width: '100% ',
    },
  },

  footerBackground: {
    overflow: 'hidden',
    background: '#000',
    position: 'absolute',
    bottom: '0',
    width: '100%',
    height: '100%',
    zIndex: '-1',
    // padding: '20px 0',
    [theme.breakpoints.down('xs')]: {
      // height: '7%',
    },
  },

  boxSocialMedia: {
    width: '50%',
    display: 'flex',
    justifyContent: 'flex-end',

    '& a': {
      margin: '0 0 0 10px',
      width: '23px',
      height: '23px',
    },

    '& a:hover': {
      opacity: '0.5',
      // color: 'rgba(128,128,128,0.6)',  
    },
  },

  socialMedia: {
    width: '30px',
    height: '30px',
    fill: '#fff',
    cursor: 'pointer',
    // objectFit: 'cover',
  },

  socialMediaTwitter: {
    width: '30px',
    height: '30px',
    fill: '#fff',
    cursor: 'pointer',
    // objectFit: 'cover',
  },

  footerContent: {
    width: '81%',
    maxWidth: '1136px',
    margin: '40px 16px 0px 16px',
    display: 'flex',
    color: '#000000',
    alignItems: 'center',
    position: 'relative',
    justifyContent: 'center',
    flexDirection: 'column;',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      margin: '40px 0px 0px 0px',
    },
  },

  footerBox: {
    width: '81%',
    display: 'flex',
    flexDirection: 'row',
    '& div': {
      '& span': {
        width: '100%',
      },
    },
  },

  footerlinks: {
    display: 'flex',
    flexDirection: 'column',
    width: '50%',

    '& a': {
      border: 'none',
      outline: 'none',
      backgroundColor: 'transparent',
      cursor: 'pointer',
      fontFamily: ['"Brown"'].join(','),
      letterSpacing: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      textAlign: 'center',
      fontWeight: 'bold',
      lineHeight: '1.2',
      color: '#ffffff',
      fontSize: '19px',
      textDecoration: 'none',
      alignSelf: 'flex-start',
      padding: '2px 0',
      paddingRight: '10px',
    },

    '& a:hover': {
      color: 'rgba(128,128,128,0.6)',
    },

    [theme.breakpoints.down('xs')]: {
      '& a': {
        fontSize: '18px',
        padding: '5px 0',
        textAlign: 'start',
      }
    },
  },

  footerContentP: {
    fontWeight: 'bold',
    width: '81%',
    textAlign: 'center',
    '& svg': {
      width: '100%',
      margin: '16px 0'
    },
    '& img': {
      width: '100%',
      margin: '16px 0'
    },

    '& span:hover': {
      opacity: '0.4',
    },

    [theme.breakpoints.down('xs')]: {
      width: '81%',
      '& svg': {
        width: '100%',
      },
      '& img': {
        width: '100%',
      },
    },

  },

  footerInformation: {
    fontFamily: ['"Brown"'].join(','),
    fontSize: '12px',
    fontWeight: '100',
    color: '#FFFFFF',
    width: '81%',
    textAlign: 'left',
    marginTop: '24px',
    marginBottom: '16px',

    '& ul': {
      display: 'flex',
      listStyleType: 'none',
      justifyContent: 'space-between',
      listStyle: 'none',
      padding: '0px',
      margin: '0px 0 0 0',
      flexWrap: 'wrap',

      '& li': {
        width: '100%',
        display: 'flex',
        '& span': {
          fontWeight: 'bold',
        },
      },
    },


    [theme.breakpoints.down('xs')]: {
      width: '81%',
    },
  },
}));
